"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getContext = require("recompose/getContext");

var _getContext2 = _interopRequireDefault(_getContext);

var _mapProps = require("recompose/mapProps");

var _mapProps2 = _interopRequireDefault(_mapProps);

var _withProps = require("recompose/withProps");

var _withProps2 = _interopRequireDefault(_withProps);

var _branch = require("recompose/branch");

var _branch2 = _interopRequireDefault(_branch);

var _reactReduxFirebase = require("react-redux-firebase");

var _Offline = require("./Offline");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//export const firebaseConnect = realFirebaseConnect
var FirebaseOffline = function () {
  function FirebaseOffline() {
    _classCallCheck(this, FirebaseOffline);
  }

  _createClass(FirebaseOffline, [{
    key: "auth",
    value: function auth() {
      throw new Error("firebase is offline");
    }
  }, {
    key: "database",
    value: function database() {
      throw new Error("firebase is offline");
    }
  }, {
    key: "ref",
    value: function ref() {
      throw new Error("firebase is offline");
    }
  }, {
    key: "set",
    value: function set() {
      throw new Error("firebase is offline");
    }
  }, {
    key: "push",
    value: function push() {
      throw new Error("firebase is offline");
    }
  }]);

  return FirebaseOffline;
}();

exports.default = function (query) {
  var connectIfOnline = (0, _branch2.default)(function (props) {
    return (0, _Offline.isStateOffline)(props.store.getState());
  }, (0, _withProps2.default)(function (props) {
    return {
      firebase: props.firebase || new FirebaseOffline()
    };
  }), (0, _reactReduxFirebase.firebaseConnect)(query));
  // During tests, we pass the redux store as a prop . In production, we use
  // <Provider> to provide store as context. react-redux.connect() works this
  // way.
  return (0, _branch2.default)(function (props) {
    return props.store;
  }, connectIfOnline, _lodash2.default.flowRight((0, _getContext2.default)({ store: _propTypes2.default.object }), connectIfOnline, (0, _mapProps2.default)(function (props) {
    return _lodash2.default.omit(props, ["store"]);
  })));
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/redux/firebaseConnect.js
// module id = 821
// module chunks = 0